import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParentalControls, ParentalSection } from '../../contexts/ParentalControlsContext';
import './ContentNav.css';

export interface ContentNavItem {
  id: string;
  label: string;
}

interface ContentNavProps {
  activeId?: string;
  focusedId?: string;
  items?: ContentNavItem[];
  onSelect?: (id: string) => void;
}

export const ContentNav: React.FC<ContentNavProps> = ({
  activeId,
  focusedId,
  items,
  onSelect,
}) => {
  const { t } = useTranslation();
  const { isNavVisible } = useParentalControls();

  const defaultItems: (ContentNavItem & { section?: ParentalSection })[] = [
    { id: 'tv',      label: t('nav.tv'),      section: 'liveTV' },
    { id: 'games',   label: t('nav.sports'),  section: 'sports' },
    { id: 'movies',  label: t('nav.movies'),  section: 'movies' },
    { id: 'series',  label: t('nav.series'),  section: 'series' },
    { id: 'kids',    label: t('nav.kids'),    section: 'kids' },
    { id: 'anime',   label: t('nav.anime'),   section: 'anime' },
  ];

  const navItems = (items ?? defaultItems).filter(
    (item) => !('section' in item && item.section && !isNavVisible(item.section as ParentalSection))
  );

  return (
    <nav className={`contentnav${navItems.length <= 3 ? ' contentnav--few' : ''}`} aria-label={t('nav.categories')}>
      {navItems.map((item) => (
        <button
          key={item.id}
          className={[
            'contentnav__item',
            activeId === item.id ? 'contentnav__item--active' : '',
            focusedId === item.id ? 'contentnav__item--focused' : '',
          ].filter(Boolean).join(' ')}
          onClick={() => onSelect?.(item.id)}
          type="button"
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
};
